import api from '@/lib/api';
import { Project, ProjectContact, ProjectContactInput } from '@/types';

export const toContactInput = (c: ProjectContact): ProjectContactInput => ({
    name: c.name,
    phone: c.phone,
    ...(c.role ? { role: c.role } : {}),
    ...(c.notes ? { notes: c.notes } : {}),
});

export const projectService = {
    getProjects: async () => {
        let { data } = await api.get('/projects',{
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });            
        data = data.map(project => ({
            ...project,
            tags: project.projectTags.map(tag => tag.name) || []
        }))
        return data;
    },
    createProject: async (projectData) => {
        try {
            const { data } = await api.post('/projects', projectData,{
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
                }
            });
            return data;
        } catch (error) {
            console.error('Error creating project:', error);
        }
    },
    updateProject: async (id: string, updates: Partial<Project>) => {
        const { data } = await api.patch(`/projects/${id}`, updates, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return data;
    }
}